export default {
  description: {
    id: 'bo-seller_financial-report_no_result_description',
    defaultMessage: 'Oups!',
  },
  title: {
    id: 'bo-seller_financial-report_no_result_title',
    defaultMessage: 'No financial report available',
  },
}
